import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { MDBBtn } from "mdb-react-ui-kit";
import Loader from "../Loader";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";

const GenerateDefaulterList = () => {
  const [loading, setLoading] = useState(false);

  const handleButtonClick = async () => {
    try {
      const response = await axiosInstance.get(
        `/Voting/genrate_defaulter_list`
      );
      if (response.status === 200) {
        toast.success(`Success: ${response.data.status}`, {
          autoClose: 5000,
        });
      } else {
        toast.error(`Error: ${response.data.status}`, {
          autoClose: 5000,
        });
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        autoClose: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="mt-5">
        <div className="row justify-content-center align-items-center">
          <div className="col-md-2">
            <h3 className="my-4">Genrate Defaulter List </h3>
            <MDBBtn
              onClick={() => {
                handleButtonClick();
              }}
            >
              Generate Defaulter List
            </MDBBtn>
          </div>
        </div>
      </div>
    </>
  );
};

export default GenerateDefaulterList;
